import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { Button, DisplayText, IllusEmpty_2, Image, theme } from '@sg/garnish';

import { type ScanToPayPalette, textPalettes } from '../../utils';

export const ScanToPayErrorState = (props: ScanToPayErrorStateProps) => {
  const { palette, onRefresh } = props;

  return (
    <View style={styles.container}>
      <Image source={IllusEmpty_2} style={styles.illustration} />

      <DisplayText size={4} style={[styles.heading, textPalettes[palette]]}>
        <FormattedMessage {...messages.title} />
      </DisplayText>

      <Button
        size="large"
        palette={palette === 'cream' ? 'spinachMuted' : 'light'}
        onPress={onRefresh}
      >
        <FormattedMessage {...messages.cta} />
      </Button>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing['8'],
    gap: theme.spacing['8'],
  },
  illustration: {
    width: 150,
    height: 150,
    alignSelf: 'center',
  },
  heading: {
    textAlign: 'center',
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Something went wrong, try again in a few moments...',
    description: 'Scan To Pay | Title',
  },
  cta: {
    defaultMessage: 'Refresh',
    description: 'Scan To Pay | CTA',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ScanToPayErrorStateProps = {
  palette: ScanToPayPalette;
  onRefresh: () => void;
};
